import { Flex, Text } from "@chakra-ui/react";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import { useNavigate } from "react-router-dom";
import {
  fetchAnaliseVacancy,
  setCurrentCustomer,
  setCurrentRecruiter,
  setCurrentStatus,
  setCurrentVacancyName,
  setSelectedStatus,
  setSelectedRecruiter,
  setSelectedCustomer,
} from "../../store/slices/analytics";
import DateRangePicker from "../../components/DateRangePicker/DateRangePicker";
import { useEffect, useState } from "react";
import { transformGuides } from "../../helpers/transformGuides";
import { fetchRecruiters } from "../../store/slices/vacancy";
import { fetchCustomers } from "../../store/slices/customers";
import Select from "react-select";
import { Customer } from "@/model/customers";
import { AnalyticsFilters } from "../../components/AnalyticsBlocks/AnalyticsFilters";
import { colourStylesStatusAdaptive, colourStylesRecruiterAdaptive, colourStylesCustomerAdaptive } from "../../components/AnalyticsBlocks/filterStyles";


export const VacanciesList = ({ isActive }: { isActive: boolean }) => {
  const dispatch = useAppDispatch();
  const { vacanciesList } = useAppSelector((state: RootState) => state.analytics);

  const { guides } = useAppSelector((state: RootState) => state.guides);
  const { customers } = useAppSelector((state: RootState) => state.customers);
  const { recruiters } = useAppSelector((state: RootState) => state.vacancy);

  const { customer, period_from, period_to, status, recruiter, currentDepartment, currentChannel, selectedStatus, selectedRecruiter, selectedCustomer } = useAppSelector((state: RootState) => state.analytics);

  const [statusList, setStatusLust] = useState<{ value: string; label: string }[]>([]);
  const [recruiterList, setRecruiterList] = useState<{ value: string; label: string }[]>([]);
  const [customerList, setCustomerList] = useState<{ value: string; label: string }[]>([]);


  useEffect(() => {
    if (guides) {
      const resultStatusList = transformGuides(guides.VacancyStatus);
      resultStatusList.unshift({ value: "all", label: "Все" });
      setStatusLust(resultStatusList);
    }
  }, [guides]);

  useEffect(() => {
    if (recruiters) {
      const resultRecruiters = recruiters.map((el) => ({ value: String(el.id), label: el.username }));
      resultRecruiters.unshift({ value: "all", label: "Все" });
      setRecruiterList(resultRecruiters);
    }
  }, [recruiters]);

  useEffect(() => {
    if (customers) {
      const resultCustomers = customers.items.map((el: Customer) => ({ value: String(el.id), label: el.name }));
      resultCustomers.unshift({ value: "all", label: "Все" });
      setCustomerList(resultCustomers);
    }
  }, [customers]);

  useEffect(() => {
    if (isActive) {
      dispatch(fetchRecruiters());
      dispatch(fetchCustomers({ params: { filters: { limit: "100000", offset: "0" } } }));
    }
  }, [dispatch, isActive]);

  // Инициализация сохраненных значений фильтров при первой загрузке
  useEffect(() => {
    // Если значения еще не установлены, устанавливаем "all" как значение по умолчанию
    if (selectedStatus === null && statusList.length > 0) {
      dispatch(setSelectedStatus("all"));
    }
    if (selectedRecruiter === null && recruiterList.length > 0) {
      dispatch(setSelectedRecruiter("all"));
    }
    if (selectedCustomer === null && customerList.length > 0) {
      dispatch(setSelectedCustomer("all"));
    }
  }, [dispatch, selectedStatus, selectedRecruiter, selectedCustomer, statusList.length, recruiterList.length, customerList.length]);

  // Убираем сброс фильтров при размонтировании компонента, чтобы сохранить состояние между вкладками

  const navigate = useNavigate();

  useEffect(() => {
      dispatch(
        fetchAnaliseVacancy({
          period_from: period_from,
          period_to: period_to,
          vacancy_status: status,
          recruiter_id: recruiter,
          customer_id: customer,
          department_id: currentDepartment === 0 ? null : currentDepartment,
          channel_id: currentChannel === 0 ? null : currentChannel,
        }),
      );
  }, [period_from, period_to, status, recruiter, customer, currentDepartment, dispatch, isActive, currentChannel]);

  return (
    <Flex flexDirection="column">
      <AnalyticsFilters 
        isActive={isActive}
        additionalFilters={
          <>
            <DateRangePicker />
            <Select
              menuPosition="fixed"
              className="basic-single"
              classNamePrefix="select"
              isSearchable={false}
              name="status"
              styles={colourStylesStatusAdaptive}
              options={statusList}
              placeholder="Выберите статус"
              value={statusList.find(item => item.value === (selectedStatus || "all")) || null}
              onChange={(arg) => {
                if (arg) {
                  dispatch(setSelectedStatus(arg.value));
                  dispatch(setCurrentStatus(arg.value === "all" ? null : Number(arg.value)));
                }
              }}
            />
            <Select
              menuPosition="fixed"
              className="basic-single"
              classNamePrefix="select"
              isSearchable={false}
              name="recruiter"
              styles={colourStylesRecruiterAdaptive}
              options={recruiterList}
              placeholder="Выберите рекрутера"
              value={recruiterList.find(item => item.value === (selectedRecruiter || "all")) || null}
              onChange={(arg) => {
                if (arg) {
                  dispatch(setSelectedRecruiter(arg.value));
                  dispatch(setCurrentRecruiter(arg.value === "all" ? null : Number(arg.value)));
                }
              }}
            />
            <Select
              menuPosition="fixed"
              className="basic-single"
              classNamePrefix="select"
              isSearchable={false}
              name="customer"
              styles={colourStylesCustomerAdaptive}
              options={customerList}
              placeholder="Выберите заказчика"
              value={customerList.find(item => item.value === (selectedCustomer || "all")) || null}
              onChange={(arg) => {
                if (arg) {
                  dispatch(setSelectedCustomer(arg.value));
                  dispatch(setCurrentCustomer(arg.value === "all" ? null : Number(arg.value)));
                }
              }}
            />
          </>
        }
      />
      <Text fontSize="27px" fontWeight={600} color="#3b515e" marginTop="16px">
        Вакансии → воронка
      </Text>
      <Flex flexDirection="column" gap="16px" bgColor="white" borderRadius="8px" border="1px solid #e1e7ef" padding="16px" marginTop="16px">
        <Text fontSize="24px" fontWeight={600} color="#3b515e">Список вакансий</Text>
        
        {/* Шапка таблицы */}
        <Flex w="100%" borderBottom="2px solid #e1e7ef" paddingBottom="12px">
          <Flex flex="1" paddingLeft="12px">
            <Text fontSize="16px" fontWeight={600} color="#3b515e">
              Название вакансии
            </Text>
          </Flex>
          <Flex flex="1" justifyContent="center">
            <Text fontSize="16px" fontWeight={600} color="#3b515e">
              Кандидаты
            </Text>
          </Flex>
          <Flex flex="1" justifyContent="center">
            <Text fontSize="16px" fontWeight={600} color="#3b515e">
              Статус
            </Text>
          </Flex>
        </Flex>

        {/* Контент таблицы */}
        <Flex flexDirection="column" w="100%" gap="4px">
          {vacanciesList.map((el) => {
            return (
              <Flex
                key={el.id}
                w="100%"
                alignItems="center"
                padding="12px"
                borderRadius="4px"
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                    backgroundColor: "#f7f9fc",
                  },
                }}
                onClick={() => {
                  dispatch(fetchAnaliseVacancy({ vacancy_id: el.id })).finally(() => {
                    dispatch(setCurrentVacancyName(el.name));
                    navigate(`${el.id}`);
                  });
                }}
              >
                <Flex flex="1">
                  <Text fontSize="16px" color="#3b515e" fontWeight={500}>
                    {el.name}
                  </Text>
                </Flex>
                <Flex flex="1" justifyContent="center">
                  <Text fontWeight={600} fontSize="14px" color="#3b515e" padding="2px 8px" borderRadius="9999px" border="1px solid #e1e7ef">
                    {el.total} из {el.total_absolute}
                  </Text>
                </Flex>
                <Flex flex="1" justifyContent="center">
                  <Text fontSize="16px" color="#3b515e">
                    {el.status}
                  </Text>
                </Flex>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};
